<div class="flex align-items-center justify-content-center w-full font-bold border-round m-2 text-3xl title-case">
    Transfer Contract
</div>
<p-card>
    <form #transferForm="ngForm" (ngSubmit)="onTransferContractClicked()" novalidate>
        <div class="form-group">
            <div class="field-inputs">
                <label for="currentPac" class="required-field">Current PAC : </label>
                <input id="currentPac" class="form-control" pattern="^[a-zA-Z0-9]+$" maxlength="13" minlength="12"
                    [(ngModel)]="pacData.currentPac" name="currentPac" #currentPac="ngModel" pInputText required />
                <label for="manufacturer" class="required-field">Manufacturer : </label>
                <p-dropdown class="form-control" [options]="manufacturers" optionLabel="manufacturerName"
                    placeholder="Select Manufacturer" [(ngModel)]="selectedManufaturer" [filter]="true"
                    id="manufacturer" [ngModelOptions]="{standalone: true}" optionValue="manufacturerName"></p-dropdown>
                <div class="info-wrapper">
                    <span>
                        <i class="pi pi-info-circle"></i>Selected manufacturer must match specified PAC(s) for transfer
                        to succeed.
                    </span>
                </div>
            </div>
            <div class="error-msg" *ngIf="currentPac.invalid  &&  (currentPac.dirty || currentPac.touched)">
                <span *ngIf="currentPac?.errors?.required">
                    Current PAC is required</span>
                <span *ngIf="currentPac?.errors?.pattern">
                    Current PAC should be alphanumeric</span>
                <span *ngIf="currentPac?.errors?.maxlength && !currentPac?.errors?.pattern">
                    Maximum length of the Current PAC should be 13
                </span>
                <span *ngIf="currentPac?.errors?.minlength && !currentPac?.errors?.pattern">
                    Minimum length of the Current PAC should be 12
                </span>
            </div>
            <div class="field-inputs">
                <label for="newPac" class="required-field">New PAC : </label>
                <input id="newPac" class="form-control" pattern="^[a-zA-Z0-9]+$" maxlength="13" minlength="12"
                    [(ngModel)]="pacData.newPac" name="newPac" #newPac="ngModel" pInputText required />
            </div>
            <div class="error-msg" *ngIf="newPac.invalid && (newPac.dirty || newPac.touched)">
                <span *ngIf="newPac?.errors?.required">
                    New PAC is required</span>
                <span *ngIf="newPac?.errors?.pattern">
                    New PAC should be alphanumeric</span>
                <span *ngIf="newPac?.errors?.maxlength && !newPac?.errors?.pattern">
                    Maximum length of the New PAC should be 13
                </span>
                <span *ngIf="newPac?.errors?.minlength && !newPac?.errors?.pattern">
                    Minimum length of the New PAC should be 12
                </span>
            </div>
            <div class="field-inputs">
                <div class="notes-buttons-wrapper">
                    <div class="notes-wrapper">
                        <label for="notes">Notes : </label>
                        <textarea id="notes" placeholder="Reason to Transfer" pInputTextarea
                            [ngModelOptions]="{standalone: true}" [(ngModel)]="notes"></textarea>
                    </div>
                    <div class="field-buttons">
                        <small></small>
                        <button pButton type="submit" label="Transfer Contract"
                            [disabled]="currentPac.invalid || newPac.invalid || selectedManufaturer === undefined"></button>
                    </div>
                </div>
                <div class="info-wrapper">
                    <span>
                        <i class="pi pi-info-circle"></i>Notes:
                    </span>
                    <span>
                        - All contracts associated with the specified PAC(s) will be transfered and the old unit will be
                        deactivated.
                    </span>
                </div>
            </div>
        </div>
    </form>
</p-card>
<p-toast styleClass="custom-toast" life="10000" position="top-center"></p-toast>
<p-confirmDialog icon="pi pi-exclamation-triangle"></p-confirmDialog>